module.exports = __webpack_public_path__ + "static/media/znalezione.64521506.gif";